import React from 'react';
import { useField } from 'formik';
import { composeValidators, requiredValidator } from 'sd-formik-validators';
import { StyledTextField } from './StyledTextField';
const validateZip = () => {
  return undefined;
};
export const ZipCodeField = ({
  isRequired = false,
  name,
  label,
  validate = [],
  helperText = '',
  error = '',
  onFieldValueChange = () => {},
  ...props
}) => {
  const [field, meta] = useField({
    name,
    validate: isRequired
      ? composeValidators(requiredValidator, validateZip, ...validate)
      : composeValidators(validateZip, ...validate)
  });

  return (
    <StyledTextField
      {...field}
      value={(field && field.value) || ''}
      onChange={e => {
        const value = e.target.value.trim();
        if (value.length > 9) {
          return;
        }
        field.onChange(e);
        onFieldValueChange(value);
      }}
      label={isRequired && label ? `*${label}` : label}
      error={!!(meta.touched && meta.error) || error}
      helperText={!!(meta.touched && meta.error) ? meta.error : helperText}
      style={{
        ...props.style,
        marginBottom: Boolean(meta.touched && meta.error)
          ? '4px'
          : (!!props && !!props.style && props.style.marginBottom) || ''
      }}
      {...props}
    />
  );
};
